export const INPUT_LABEL = 'links.gemspace.com/join/';
export const INPUT_MAX_LENGTH = 35;
